import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShoppingBag, Heart } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { VirtualBagModal } from './VirtualBagModal';

export function VirtualBagCard() {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);

  if (!user) return null;

  return (
    <>
      <Card className="rounded-2xl bg-gradient-to-br from-rose-50 to-pink-50 dark:from-rose-950/20 dark:to-pink-950/20 border border-rose-200 dark:border-rose-800/40">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-sm font-bold">
            <ShoppingBag className="h-4 w-4 text-rose-600 dark:text-rose-400" />
            Sacola Virtual U-Clean
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-xs text-muted-foreground mb-3 leading-relaxed">
            Contribua com qualquer valor e ajude a manter a
            <strong> U-Clean</strong> funcionando.
          </p>
          <Button
            onClick={() => setShowModal(true)}
            className="w-full rounded-xl bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white"
            size="sm"
            data-testid="open-virtual-bag-btn"
          >
            <Heart className="h-3.5 w-3.5 mr-1.5" />
            Apoiar a U-Clean
          </Button>
        </CardContent>
      </Card>

      <VirtualBagModal 
        open={showModal} 
        onClose={() => setShowModal(false)} 
      />
    </>
  );
}
